// Which session the home screen offers: the one that is live now, else the next one with a date
// that the person is not turning down. A draft has no date and so is not "planned" yet, and a plan
// nobody started within a day of its time is over (the edge closes it too; this covers a list that
// was fetched earlier or by an older edge).
import { plannedSessionLapsed } from "@proef/domain";
import type { SessionSummary } from "./sessionsApi";

const going = (session: SessionSummary): boolean => session.rsvp !== "no" && !session.cancelled;

export function nextPlanned(
  live: readonly SessionSummary[],
  upcoming: readonly SessionSummary[],
  now: Date = new Date(),
): SessionSummary | undefined {
  const current = live.find(going);
  if (current !== undefined) return current;
  return upcoming
    .filter(
      (session) =>
        going(session) &&
        session.scheduledAt !== null &&
        !plannedSessionLapsed(session.scheduledAt, now),
    )
    .toSorted((a, b) => (a.scheduledAt ?? "").localeCompare(b.scheduledAt ?? ""))[0];
}
